<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
      <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
      <div class="cs-fullHeight cs-contentContainer-right">
        <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
          <el-row>
            <el-col>
              <div v-if="isReadonly">
                <span class="cs-title">组织结构图</span>
                <orgChartDiagram></orgChartDiagram>
              </div>
              <el-tabs v-else v-model="activeTab" type="card">
                <el-tab-pane name="1">
                  <span slot="label">组织结构图</span>
                  <el-row class="grid-content">
                    <el-col>
                      <orgChartDiagram></orgChartDiagram>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane name="2">
                  <span slot="label">人员历史记录</span>
                  <el-row class="grid-content">
                    <el-col>
                      <personnelHistoryList></personnelHistoryList>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-col>

  </el-row>
</template>

<script>
import {
    redirect
} from "../../config/mUtils";
import { getGlobalSettingValuesByTypeList } from "../../service/common.service";

export default {
  name: "orgChart",
  components: {
    navigator: () => import("@/components/navigator"),
    orgChartDiagram: () =>
      import("@/components/orgChart/orgChartDiagram"),
    personnelHistoryList: () =>
      import("@/components/orgChart/personnelHistoryList"),
  },
  data() {
    return {
      isReadonly: false,
      activeTab: "1"
    };
  },
  created() {
    this.isReadonly =
      !this.USERMANAGER.isAdmin && !this.USERMANAGER.isPersonnelManagement;

    let typeList = [
      this.GLOBAL.enumGlobalSettingType.HasOrganizationChart
    ];
    getGlobalSettingValuesByTypeList(typeList).then(result => {
      if (result && result.success){
        if (!result.data.HasOrganizationChart){
          redirect(this.$router, this.USERMANAGER);
        }
      }
    });
      
  },
  computed: {},
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/admin/orgChart.vue